import styled from '@emotion/styled';
import { boxSizes, colors, fontSizes, fontWeights, gutterSizes } from '@gumtree/ui-library/src/base/theme';

export const ItemContainer = styled.div<{ isSegmented?: boolean }>`
    margin-bottom: ${gutterSizes.xlarge};
    ${({ isSegmented }) =>
        isSegmented &&
        `
        display: grid;
        grid-template-columns: 2fr 1fr;
        grid-template-rows: auto auto;
        gap: 0;
        align-items: center;
    `}
`;

export const Label = styled.label<{ error?: boolean; isSegmented?: boolean }>`
    display: block;
    margin-bottom: ${({ isSegmented }) => (isSegmented ? '0' : gutterSizes.base)};
    color: ${({ error, isSegmented }) => (error && !isSegmented ? colors.fgDanger : colors.messageTextColor)};
    font-weight: ${fontWeights.lightBold};
    ${({ isSegmented }) =>
        isSegmented &&
        `
        grid-column: 1;
        grid-row: 1;
        justify-self: start;
        align-self: center;
        margin-right: 0;
        width: 100%;
    `}
`;

export const ErrorText = styled.div<{ isSegmented?: boolean }>`
    color: ${colors.fgDanger};
    font-size: ${fontSizes.small14};
    margin-top: ${({ isSegmented }) => (isSegmented ? '0' : gutterSizes.small)};
    ${({ isSegmented }) =>
        isSegmented &&
        `
        grid-column: 1 / -1;
        grid-row: 2;
        justify-self: start;
        margin-top: ${gutterSizes.small};
    `}
`;

export const InputBox = styled.input<{ error?: boolean; minLength?: number }>`
    box-sizing: border-box;
    width: 100%;
    border: 1px solid ${({ error }) => (error ? colors.fgDanger : '#BFC5C9')};
    border-radius: ${boxSizes.borderRadius4};
    padding: ${gutterSizes.medium};
    color: ${colors.messageTextColor};
    &:focus {
        outline: none;
        border-color: ${colors.messageTextColor};
    }
`;

export const TextAreaBox = styled.textarea<{ error?: boolean; minLength?: number }>`
    box-sizing: border-box;
    width: 100%;
    border: 1px solid ${({ error }) => (error ? colors.fgDanger : '#BFC5C9')};
    border-radius: ${boxSizes.borderRadius4};
    padding: ${gutterSizes.medium};
    color: ${colors.messageTextColor};
    min-height: 100px;
    resize: vertical;
    &:focus {
        outline: none;
        border-color: ${colors.messageTextColor};
    }
`;

export const SelectBox = styled.select<{ error?: boolean }>`
    width: 100%;
    border: 1px solid ${({ error }) => (error ? colors.fgDanger : '#BFC5C9')};
    border-radius: ${boxSizes.borderRadius4};
    padding: ${gutterSizes.medium};
    padding-right: ${gutterSizes.large40};
    color: ${colors.messageTextColor};
    background: ${colors.white};
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.47492 10H16.5251C16.947 10 17.1591 10.594 16.8601 10.942L13.6203 14.7143C13.0253 15.4069 12.3442 16 12.0004 16C11.6565 16 10.9754 15.4069 10.3805 14.7143L7.13989 10.942C6.84094 10.594 7.053 10 7.47492 10Z' fill='%23495660'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right ${gutterSizes.medium} center;
    
    &:focus {
        outline: none;
        border-color: ${colors.messageTextColor};
    }
`;

export const SegmentedButtonsWrapper = styled.div`
    grid-column: 2;
    grid-row: 1;
    justify-self: end;
    align-self: center;
    width: 100%;
`;

export const CheckboxGroup = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${gutterSizes.small};
    align-items: start;
`;

export const CheckboxLabel = styled.label`
    display: flex;
    align-items: center;
    gap: ${gutterSizes.small};
`;
